import { render, staticRenderFns } from "./detail_site.vue?vue&type=template&id=3121d762&scoped=true&"
import script from "./detail_site.vue?vue&type=script&lang=js&"
export * from "./detail_site.vue?vue&type=script&lang=js&"
import style0 from "./detail_site.vue?vue&type=style&index=0&id=3121d762&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121d762",
  null
  
)

export default component.exports